import * as core from '../../../../../../../core'
import * as changeImpactDepartment from '../change-impact-department'

export const RESOURCE = {
  payload: {
    description: 'Development / Fundraising',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactDepartment.RESOURCE.payload.partialId,
    }),
    id: 'Development / Fundraising',
    name: 'Development / Fundraising',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
